import './UserGroupsPage.css'
import React, { useEffect, useState } from "react";
import Header from '../../components/common/Header/Header';
import { AppDispatch } from '../../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import UserGroupsContainer from './components/UserGroupsContainer';
import { fetchUserGroups } from '../../redux/actions/userGroups.actions';
import UpdateUserGroupModal from './components/modals/UpdateUserGroupModal';
import DeleteUserGroupModal from './components/modals/DeleteUserGroupModal';
import RootState from '../../redux/states/root.state';
import { UsersIcon } from '../../components/common/Icons/Icons';

const UserGroupsPage = () => {
  const dispatch: AppDispatch = useDispatch();
  const searchParams = useSearchParams()[0];
  const {meta} = useSelector((state: RootState) => state.userGroups);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [userGroupToModify, setUserGroupToModify] = useState<any>(null);

  // Dispatch UseEffects
  useEffect(() => {
    dispatch(fetchUserGroups(searchParams.toString()));
  }, [dispatch, searchParams]);

  return (
    <div className="page lp-page">
      <UpdateUserGroupModal isOpen={editOpen} setOpen={setEditOpen} userGroup={userGroupToModify} params={searchParams.toString()}/>
      <DeleteUserGroupModal open={deleteOpen} setOpen={setDeleteOpen} userGroup={userGroupToModify} params={searchParams.toString()}/>
      <Header
        header="User Groups"
        headerExtra={meta?.total !== undefined &&
          <ul className="lp-stats" aria-label="Summary">
            <li className="lp-stat"><UsersIcon/><b>{(meta?.total ?? 0).toLocaleString()}</b> Groups</li>
          </ul>
        }
      />
      <main className="lp-main">
        <UserGroupsContainer
          setEditOpen={setEditOpen}
          setDeleteOpen={setDeleteOpen}
          setUserGroupToModify={setUserGroupToModify}
        />
      </main>
    </div>
  );
};

export default UserGroupsPage;
